import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


const __default__ = {
  name: 'ImportDialog'
};

import {
  OioButton,
  OioForm,
  OioFormItem,
  OioMessage,
  OioModal,
  OioNotification,
  OioPagination,
  getEasyImportTemplate
} from '@kunlun/vue-ui-antd';
import { computed, reactive, ref, toRefs, watch } from 'vue';
import {
  OioTable,
  OioColumn,
  TableSize,
  ValidatorStatus,
  translate,
  RuntimeModel,
  ModelFieldType,
  RuntimeModelField,
  buildSingleItemParam
} from '@kunlun/dependencies';
import { queryWorkbook, validateData } from '../../api';
import { clickUploadExcelFile } from '../../utils/excel';
import { ErrorCode, ExcelModelField, ValidateExcelError } from '../../types';

interface IProps {
  label?: string;
  // 前端自定义校验函数，不传则走后端校验需要后端配合
  // 第二个参数为当前选中的模板名称，用于多模板场景下的差异化校验
  clientValidateFuction?: (data: any, templateName?: string) => any[];
  // 第二个参数为当前选中的模板名称，用于多模板场景下的差异化回调
  importCallback: (data: any, templateName?: string) => void;
  model: RuntimeModel;
  importTemplateName: string;
  maxLength?: number;
  rowNumFiled?: string;
  validateMsgFiled?: string;
  validateFunction?: string;
  agsWithFormData?: boolean;
  formData?: any;
}

// 目前这些参数是常用的，如果后端小导入接口是从已有代码复制的，这里就不需要改

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: { default: '导入' },
    clientValidateFuction: null,
    importCallback: null,
    model: null,
    importTemplateName: null,
    maxLength: { default: 50000 },
    rowNumFiled: { default: 'rowNum' },
    validateMsgFiled: { default: 'validateMsg' },
    validateFunction: { default: 'formTableImportWidgetV2Validate' },
    agsWithFormData: { type: Boolean, default: false },
    formData: { default: '' }
  },
  setup(__props: any) {

const props = __props as { label: string, clientValidateFuction?: (data: any, templateName?: string) => any[], importCallback: (data: any, templateName?: string) => void, model: RuntimeModel, importTemplateName: string, maxLength: number, rowNumFiled: string, validateMsgFiled: string, validateFunction: string, agsWithFormData: boolean, formData: any }



const errorArr = reactive<any[]>([]);
const errorTableColums = reactive<any[]>([]);
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
});
const showErrorModal = ref(false);
const selectValue = ref('');
const importLoading = ref(false);
const show = ref(false);
const validation1 = reactive({
  status: '',
  help: ''
});
const workbookList = reactive<any[]>([]);
const headerFieldsArrMap = reactive({
  enFieldsArr: [] as any[],
  enFieldsKeyArr: [] as any[],
  cnFieldsArr: [] as any[]
});
const headerFields = reactive<any[]>([]);
const copyModleFields = reactive<RuntimeModelField[]>([]);

const viewList = computed(() => {
  return errorArr?.slice((pagination.current - 1) * pagination.pageSize, pagination.current * pagination.pageSize);
});

const handleSelectChange = (value: string) => {
  selectValue.value = value;
  // 切换模板时重新生成表头
  const selected = workbookList.find((w) => w.id === value);
  if (selected) {
    generateHeader(selected);
  }
};

const generateHeader = (workbook?: any) => {
  const target = workbook || workbookList[0];
  if (!target) return;
  const sheetDefinitions = JSON.parse(target.sheetDefinitions);
  const enFieldsArr = sheetDefinitions[0].blockDefinitionList[0].headerList[0].cellList;
  const enFieldsKeyArr = enFieldsArr.map((enField) => enField.field);
  const cnFieldsArr = sheetDefinitions[0].blockDefinitionList[0].headerList[1].cellList;
  Object.assign(headerFieldsArrMap, {
    enFieldsArr,
    enFieldsKeyArr,
    cnFieldsArr
  });
  const hf: any[] = [];
  // 注意，前端校验和后端校验的表头字段不一样
  // 前端校验，不需要掉接口，直接使用sheetDefinitions定义的字段
  if (props.clientValidateFuction) {
    enFieldsKeyArr.forEach((i, index) => {
      hf.push({
        name: i,
        field: i,
        label: cnFieldsArr[index].value,
        format: enFieldsArr[index].format,
        type: enFieldsArr[index].type
      });
    });
  }
  // 后端校验，因为需要掉接口，所以字段必须跟模型匹配
  else {
    enFieldsKeyArr.forEach((i, index) => {
      copyModleFields.forEach((j) => {
        if (j.name === i) {
          // @ts-ignore
          j.excelLabel = cnFieldsArr[index].value;
          hf.push(j);
        }
      });
    });
  }
  headerFields.splice(0, headerFields.length, ...hf);
  errorTableColums.splice(
    0,
    errorTableColums.length,
    ...headerFields.map((item) => {
      return {
        name: item.data || item.field,
        label: item.label || item.displayName,
        returnType: 'STRING'
      };
    })
  );
  errorTableColums.push({
    name: props.validateMsgFiled,
    label: '错误信息',
    returnType: 'STRING'
  });
};

const validateSelectTemplate = () => {
  if (!selectValue.value) {
    validation1.status = ValidatorStatus.Error;
    validation1.help = translate('kunlun.import.tips');
    return false;
  }
  validation1.status = '';
  validation1.help = '';
  return true;
};

const downloadTemplate = async () => {
  if (!validateSelectTemplate()) {
    return;
  }

  const urlObj: any = await getEasyImportTemplate(selectValue.value);
  window.open(urlObj.redirectUri);
};

const formatCellData = (cellData, field) => {
  const cellDataType = typeof cellData;

  if (!cellData) {
    return cellData;
  }

  // 字符串类型
  if (field.ttype == ModelFieldType.String && cellDataType !== 'string') {
    return String(cellData);
  }
  // 日期类型
  else if (field.ttype == ModelFieldType.DateTime && cellDataType !== 'string') {
    let date = new Date(cellData);
    date = new Date(date.getTime() + 43 * 1000);
    const yy = date.getFullYear();
    const mm = date.getMonth() + 1;
    const dd = date.getDate();
    const hh = date.getHours();
    const m = date.getMinutes();
    const ss = date.getSeconds();

    return `${yy}-${mm}-${dd} ${hh}:${m}:${ss}`;
  }
  // 去除小数后面的0
  else if (field.ttype == ModelFieldType.Float) {
    return Number(cellData);
  }
  // 枚举类型填充正确的值
  else if (field.ttype == ModelFieldType.Enum) {
    const index = headerFieldsArrMap.enFieldsKeyArr.indexOf(field.name as never);
    if (index === -1) {
      throw new Error('未找到枚举字段' + field.name);
    }
    const enumMapStr = headerFieldsArrMap.enFieldsArr[index].format;
    if (!enumMapStr) {
      throw new Error('枚举字段' + field.name + '未配置format');
    }
    const enumMap = JSON.parse(enumMapStr);
    for (const key in enumMap) {
      if (enumMap[key] === cellData) {
        return key;
      }
    }
  }

  return cellData;
};

const outputWorkbookByFields = (sheetList: any[], filterFields: ExcelModelField[]) => {
  const maxLength = props.maxLength;
  const importResult: any[] = [];

  if (!sheetList.length) {
    throw new ValidateExcelError(ErrorCode.OTHER, '表格数据为空');
  } else if (sheetList.length > Number(maxLength)) {
    throw new ValidateExcelError(ErrorCode.OTHER, `当前导入仅支持导入${maxLength}行明细数据导入，请核对数据后重新导入`);
  }

  // 前端校验
  if (props.clientValidateFuction) {
    const cnkeys = Object.keys(sheetList[0]);
    // 根据headerFields中的label解析data
    sheetList.forEach((item: any) => {
      const row: typeof sheetList[number] = {};
      cnkeys.forEach((key) => {
        const field = headerFields.find((field) => field.label === key);
        if (field) {
          row[field.field] = item[key];
        }
      });
      importResult.push(row);
    });
  }
  // 后端校验
  else {
    // 行数据
    rowfor: for (let i = 0; i < sheetList.length; i++) {
      const row = sheetList[i];
      const formattedRow: Record<string, any> = {};

      // 表头对应的字段
      for (let j = 0; j < filterFields.length; j++) {
        const field = filterFields[j];
        const cellData = formatCellData(row[field.excelLabel!], field);
        if (typeof cellData === 'string') {
          if (cellData.trim()) {
            formattedRow[field.name] = cellData.trim();
          }
        } else {
          formattedRow[field.name] = cellData;
        }
        formattedRow.rowNum = i + 1; // 行号
      }

      importResult.push(formattedRow);
    }
  }

  return importResult;
};

const validateExcelDataAfterOutput = async (resultList: any[]) => {
  let { rowNumFiled, validateMsgFiled, validateFunction, agsWithFormData } = props;
  const configFields = [rowNumFiled, validateMsgFiled].map((i, index) => ({
    label: index === 0 ? '行号' : '错误信息',
    name: i,
    ttype: ModelFieldType.String
  }));
  errorTableColums.splice(0, errorTableColums.length, ...[...headerFields, ...configFields]);

  const promiseArr: Promise<any>[] = resultList.map(async (i) => await buildSingleItemParam(errorTableColums, i));
  const importData = await Promise.all(promiseArr);
  const modelFields = [...copyModleFields.filter((i) => i.name !== 'id'), ...configFields];
  try {
    const results = await validateData(
      { ...props.model, modelFields },
      validateFunction,
      importData,
      agsWithFormData ? JSON.stringify(JSON.stringify(props.formData)) : ''
    );
    errorArr.splice(0, errorArr.length, ...(results.filter((i) => i[validateMsgFiled]) || []));

    return {
      successData:results.filter((i) => !i[validateMsgFiled]) || [],
      errorData:results.filter((i) => i[validateMsgFiled]) || [],
    };
  } catch (error) {
    OioMessage.error('excel数据格式错误，请检查excel数据。');
    throw error;
  }
};

const handleImport = async () => {
  if (!validateSelectTemplate()) {
    return;
  }

  try {
    const data = await clickUploadExcelFile();
    importLoading.value = true;
    let parsedData = outputWorkbookByFields(data, headerFields);
    // 前端校验
    if (props.clientValidateFuction) {
      const selectedWorkbook = workbookList.find((w) => w.id === selectValue.value);
      const templateName = selectedWorkbook?.name || '';
      errorArr.splice(
        0,
        errorArr.length,
        ...props.clientValidateFuction(parsedData, templateName).filter((item) => item.validateMsg)
      );
      if (errorArr.length) {
        pagination.total = errorArr.length;
        showErrorModal.value = true; 
        throw new Error('导入失败，请查看错误信息并修改后重新导入');
      }
    }
    // 后端校验
    else {
      pagination.total = 0
      const callBackData = await validateExcelDataAfterOutput(parsedData);
      parsedData = callBackData.successData
    }
    if (props.importCallback) {
      const selectedWorkbook = workbookList.find((w) => w.id === selectValue.value);
      const templateName = selectedWorkbook?.name || '';
      await props.importCallback(parsedData, templateName);
    }
    if (errorArr.length > 0) {
        pagination.total = errorArr.length;
        showErrorModal.value = true;
        throw new Error('部分数据导入失败，请查看错误信息并修改后重新导入');
    }else {
      show.value = false;
      OioNotification.success('导入成功');
    }
   
  } catch (error) {
    console.error(error);
    if (error instanceof Error) {
      OioNotification.error('错误', error.message);
    }
  } finally {
    importLoading.value = false;
  }
};

// 监听打开弹窗获取导入模板列表
watch(show, async (value) => {
  if (value && !workbookList.length) {
    const res = (await queryWorkbook(props.model, false, props.importTemplateName)).content;
    workbookList.splice(0, workbookList.length, ...res);
    copyModleFields.splice(0, copyModleFields.length, ...(props.model?.modelFields ?? []));
    // 多模板时默认选中第一个
    if (workbookList.length > 0) {
      selectValue.value = workbookList[0].id;
    }
    generateHeader();
  }
  if (!value) {
    importLoading.value = false;
  }
  errorArr.length = 0;
});

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(OioButton), {
      class: "oio-action-item",
      size: "small",
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = true))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ]),
      _: 1
    }),
    _createVNode(_unref(OioModal), {
      width: "60%",
      visible: show.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((show).value = $event)),
      title: "导入"
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: downloadTemplate,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("下载模板")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          onClick: handleImport,
          type: "primary",
          loading: importLoading.value,
          disabled: importLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("导入")
          ]),
          _: 1
        }, 8, ["loading", "disabled"]),
        (errorArr?.length)
          ? (_openBlock(), _createBlock(_unref(OioButton), {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showErrorModal.value = true)),
              type: "primary",
              danger: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("查看导入错误信息")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(OioForm), null, {
          default: _withCtx(() => [
            _createVNode(_unref(OioFormItem), {
              label: "导入模板",
              required: true,
              validateStatus: validation1.status,
              help: validation1.help
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  value: selectValue.value,
                  onChange: handleSelectChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workbookList, (workbook) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: workbook.id,
                        key: workbook.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(workbook.displayName || workbook.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["validateStatus", "help"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      width: "60%",
      visible: showErrorModal.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showErrorModal).value = $event)),
      title: "错误信息"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(OioTable), {
          size: _unref(TableSize).small,
          showOverflow: "",
          showHeaderOverflow: "",
          border: "",
          resizable: "",
          data: _unref(viewList),
          scrollX: { gt: -1 },
          scrollY: { gt: -1 },
          tooltipConfig: { enterable: true },
          height: "400px",
          columnConfig: { useKey: true },
          sortConfig: { remote: true }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorTableColums, (column, index) => {
              return (_openBlock(), _createBlock(_unref(OioColumn), {
                key: index,
                label: column.label,
                field: column.returnType === 'ENUM' ? column.name.split('Str')[0] : column.name
              }, null, 8, ["label", "field"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["size", "data"]),
        _createVNode(_unref(OioPagination), {
          style: {"margin-top":"12px"},
          current: pagination.current,
          "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((pagination.current) = $event)),
          "page-size": pagination.pageSize,
          "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((pagination.pageSize) = $event)),
          total: pagination.total,
          "show-total": (total) => `${total} 条`,
          "show-quick-jumper": ""
        }, null, 8, ["current", "page-size", "total", "show-total"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})